import React, { useState } from "react";
import { TextField, Dialog } from "@mui/material";
// import { forgotPasswordResetPassword } from '../../actions/authActions';
import { useSelector } from "react-redux";
import { toastMessage } from "../../helper";
import { resetPassword } from "../../actions/authActions";
import CloseIcon from "@mui/icons-material/Close";
import "./LoginResetPassword.scss";
import { useTranslation } from "react-i18next";
import { STRONG_PASSWORD_REGEX } from "../../constants/regexConstants";
import { errorMessage } from "../../constants/messageConstants";

const LoginResetPassword = (props: any) => {
  const { t, i18n } = useTranslation();
  const { open, onClose } = props;
  const handleClose = () => {
    onClose({ type: "resetPassword" });
  };
  const auth = useSelector((state: any) => state.auth);
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    verifyPassword: "",
  });

  // const [password,setPassword]= useState('');
  // const [newPassword,setnewPassword]= useState('');
  const [errorPassword, setErrorPassword] = useState("");
  // const [errornewPassword,setErrorverifyPassword]= useState('');
  const { currentPassword, newPassword, verifyPassword } = formData;
  const [isLoading, setIsLoading] = useState(false);

  const validatePassword = (password: any) => {
    if (!STRONG_PASSWORD_REGEX.test(password)) {
      return errorMessage().STRONG_PASSWORD_REGEX_ERROR;
    }
    return true;
  };

  const validateForm = () => {
    return (
      currentPassword &&
      validatePassword(newPassword) === true &&
      newPassword &&
      verifyPassword &&
      !errorPassword &&
      !isLoading
    );
  };
  const onChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrorPassword("");
    if (
      e.target.name === "verifyPassword" &&
      newPassword &&
      e.target.value !== newPassword
    ) {
      setErrorPassword("Passwords do not match");
    } else if (
      e.target.name === "newPassword" &&
      verifyPassword &&
      e.target.value !== verifyPassword
    ) {
      setErrorPassword("Passwords do not match");
    }
  };

  const onSubmit = async (e: any) => {
    if (validateForm()) {
      setIsLoading(true);
      resetPassword(auth.username, currentPassword, newPassword, verifyPassword)
        .then(() => {
          // navigateToResetSuccess();
          setIsLoading(false);
          toastMessage("Password Changed Succesfully !!", "success");
          handleClose();
        })
        .catch((err: any) => {
          setIsLoading(false);
          toastMessage(err.response.data.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        });
    }
    e.preventDefault();
    // if (password !== password2) {
    //setAlert('Passwords do not match', 'danger');
    // } else {
    //register({ name, email, password });

    // }
  };
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleClose}
    >
      <div className="flex">
        <div className="flex flex-col w-40v pw-padding-4 pw-overflow-y-auto">
          <div className="pw-tab-label" id="simple-dialog-title">
            {t("Reset Password")}
          </div>
          <CloseIcon
            className="absolute pw-reset-close"
            onClick={handleClose}
          />
          <div className="pw-margin-top-5">
            <div className="pw-input-label">{t("Old Password")}</div>
            <TextField
              type="password"
              variant="outlined"
              placeholder={t("Enter Old Password")}
              size="small"
              name="currentPassword"
              className="pw-width-100 pw-input-field"
              value={currentPassword}
              onChange={(e) => onChange(e)}
            />
          </div>
          <div className="pw-margin-top-5">
            <div className="pw-input-label">{t("New Password")}</div>
            <TextField
              type="password"
              variant="outlined"
              placeholder={t("New Password")}
              size="small"
              name="newPassword"
              className="pw-width-100 pw-input-field"
              value={newPassword}
              onChange={(e) => onChange(e)}
            />
            {newPassword?.length ? (
              <span className="pw-display-error">
                {validatePassword(newPassword)}
              </span>
            ) : (
              ""
            )}
          </div>
          <div className="pw-margin-top-5">
            <div className="pw-input-label">{t("Confirm New Password")}</div>
            <TextField
              type="password"
              variant="outlined"
              placeholder={t("Confirm New Password")}
              size="small"
              name="verifyPassword"
              className="pw-width-100 pw-input-field"
              value={verifyPassword}
              onChange={(e) => onChange(e)}
            />
            {errorPassword ? (
              <span className="pw-display-error">* {errorPassword}</span>
            ) : (
              ""
            )}
          </div>
          <input
            type="button"
            className={`pw-cursor-pointer pw-margin-top-5 ${
              validateForm() ? "pw-primary-button" : "pw-neutral-background"
            }`}
            value={t("Reset Password")}
            onClick={(e) => (validateForm() ? onSubmit(e) : "")}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default LoginResetPassword;
